var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "portlet light bordered" },
    [
      _c("div", { staticClass: "portlet-title" }, [
        _c("div", { staticClass: "caption" }, [
          _c("i", { staticClass: "icon-equalizer font-red-sunglo" }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "caption-subject font-red-sunglo bold uppercase" },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm._f("trans")("purchase_order.purchase_orders")) +
                  "\n                "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "caption-helper" }, [
            _vm._v(_vm._s(_vm._f("trans")("purchase_order.panel")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "view-loader",
        {
          attrs: { loading: !!_vm.loading },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [
                  _c("h2", [
                    _vm._v(_vm._s(_vm._f("trans")("please_wait")) + "...")
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("purchase-order-materials-search", {
            attrs: { disabled: !!_vm.disabled },
            on: { request: _vm.onSearchRequest, response: _vm.onSearchResponse }
          }),
          _vm._v(" "),
          _vm.wasSearched && _vm.items.length
            ? _c("purchase-order-materials", {
                attrs: {
                  items: _vm.items,
                  disabled: !!_vm.disabled,
                  "is-dev": _vm.isDev,
                  "is-forecast": _vm.isForecast
                },
                on: {
                  request: function($event) {
                    _vm.loading++
                  },
                  response: function($event) {
                    _vm.loading--
                  },
                  disable: _vm.onDisable
                }
              })
            : _vm.wasSearched && !_vm.loading
            ? _c("div", { staticClass: "alert alert-info" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("trans")("grid.no_data_message")) +
                    "\n        "
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73b64837", { render: render, staticRenderFns: staticRenderFns })
  }
}